__turbopack_context__.v({
  "brand": "WtGTjW_brand",
  "brandLink": "WtGTjW_brandLink",
  "caption": "WtGTjW_caption",
  "desktopLinks": "WtGTjW_desktopLinks",
  "divider": "WtGTjW_divider",
  "footer": "WtGTjW_footer",
  "footerBottom": "WtGTjW_footerBottom",
  "footerInner": "WtGTjW_footerInner",
  "footerLinks": "WtGTjW_footerLinks",
  "footerRow": "WtGTjW_footerRow",
  "footerTagline": "WtGTjW_footerTagline",
  "footerText": "WtGTjW_footerText",
  "groupLinks": "WtGTjW_groupLinks",
  "header": "WtGTjW_header",
  "inlineWordmark": "WtGTjW_inlineWordmark",
  "linkGroup": "WtGTjW_linkGroup",
  "logo": "WtGTjW_logo",
  "mobileLinks": "WtGTjW_mobileLinks",
  "particles": "WtGTjW_particles",
  "pill": "WtGTjW_pill",
  "previewBooking": "WtGTjW_previewBooking",
  "previewLanguage": "WtGTjW_previewLanguage",
  "previewSignIn": "WtGTjW_previewSignIn",
  "toggle": "WtGTjW_toggle",
  "wordmark": "WtGTjW_wordmark",
});
